import React, { useEffect, useRef } from 'react'
import Tippy from '@tippyjs/react'
import { ReactEditor, useSlateStatic } from 'slate-react'
import { Editor, Transforms } from 'slate'

import { formatShortcut } from '../../../../utils/shortcuts/formatShortcut'

import { TableDeleteRowIcon, TableAddRowBeforeIcon, TableAddRowAfterIcon } from '../../../utils/Icon'
import { deleteRow, insertRowBefore, insertRowAfter, ROW_EXCEED_COUNT } from '../utils/index'
import ToolTip from '../../../../../../Tooltip/Tooltip'

import styles from '../style.module.css'
import RTE_SHORTCUT from '../../../../../../../utils/common-rte-utils/shortcuts.constant'

function SvgComponent(props) {
    const { path } = props
    const editor = useSlateStatic()
    const [iconOfNode] = Editor.node(editor, path) as any
    const rows = iconOfNode.type === 'trgrp' ? iconOfNode.children : [iconOfNode]
    const ref = useRef<HTMLDivElement>()
    useEffect(() => {
        if (rows.length > 1) {
            const iconAttachedTo = ReactEditor.toDOMNode(editor as ReactEditor, iconOfNode).firstElementChild

            if (!iconAttachedTo) return

            const templateRows = window.getComputedStyle(iconAttachedTo).getPropertyValue('grid-template-rows')
            if (ref.current)
                ref.current.style.gridTemplateRows = templateRows
        }
    })
    const tooltipRef = useRef(null)
    const closeTooltip = (dom) => {
        if (dom) {
            if (dom.getAttribute('elementtype') === 'tr') {
                return
            }
            if (dom?._tippy) {
                dom._tippy.hide()
                return
            }
            closeTooltip(dom.parentElement)
        } else {
            return
        }
    }
    return (
        <div ref={ref} style={{ height: '100%', display: 'grid' }}>
            {rows.map((row, rowIndex) => (
                <Tippy
                    placement="right"
                    content={
                        <div
                            data-testid="dnd-row-icon-toolbar"
                            style={{ display: 'flex', alignItems: 'center' }}
                            ref={tooltipRef}>
                            <span
                                data-testid="delete-row-icon"
                                className={styles['table-column-toolbarIcon']}
                                onMouseDown={(e) => {
                                    e.preventDefault()
                                    const firstCell = [...path, rowIndex, 0]
                                    Transforms.select(editor, firstCell)
                                    Transforms.collapse(editor, { edge: 'start' })
                                    deleteRow(e, { editor })
                                    closeTooltip(tooltipRef.current)

                                }}><Tippy placement="top" className="tippy-box-dark" offset={() => [0, 20]} content={<span data-testid="delete-row-text" className={styles['scrte-table-tooltip-text']} >Delete Row</span>} ><span><TableDeleteRowIcon /></span></Tippy></span>
                            <span data-testid="insert-row-before-icon" className={styles['table-column-toolbarIcon']} onMouseDown={(e) => {
                                e.preventDefault()
                                const firstCell = [...path, rowIndex, 0]
                                closeTooltip(tooltipRef.current)
                                Transforms.select(editor, firstCell)
                                Transforms.collapse(editor, { edge: 'start' })
                                insertRowBefore(e, { editor })
                                Transforms.select(editor, firstCell)
                                Transforms.collapse(editor, { edge: 'start' })

                            }}><Tippy placement="top" className="tippy-box-dark" offset={() => [0, 20]} content={<span data-testid="add-row-up-text" className={styles['scrte-table-tooltip-text']} >Add Row to the top  <span className={styles['scrte-table-tooltip-shortcut']}>{formatShortcut(RTE_SHORTCUT.ADD_ROW_ABOVE)}</span></span>} ><span><TableAddRowBeforeIcon /></span></Tippy></span>
                            <span data-testid="insert-row-after-icon" className={styles['table-column-toolbarIcon']} onMouseDown={(e) => {
                                e.preventDefault()
                                const firstCell = [...path, rowIndex, 0]

                                Transforms.select(editor, firstCell)
                                Transforms.collapse(editor, { edge: 'start' })
                                insertRowAfter(e, { editor })
                                closeTooltip(tooltipRef.current)
                                const nextCell = [...path.slice(0, path.length - 1), path[path.length - 1] + 1, 0]
                                Transforms.select(editor, nextCell)
                                Transforms.collapse(editor, { edge: 'start' })

                            }}><Tippy placement="top" className="tippy-box-dark" offset={() => [0, 20]} content={<span data-testid="add-row-down-text" className={styles['scrte-table-tooltip-text']} >Add Row to the bottom  <span className={styles['scrte-table-tooltip-shortcut']}>{formatShortcut(RTE_SHORTCUT.ADD_ROW_BELOW)}</span></span>} ><span><TableAddRowAfterIcon /></span></Tippy></span>

                        </div>
                    }
                    onTrigger={e => {
                        e.setProps({ appendTo: ref.current.parentElement })
                    }}
                    trigger="click"
                    interactive={true}
                    className="tippy-box-light tippy-box-light--primary"
                >
                    <span style={{ height: "100%" }} data-testid="row-dnd-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                            <path d="M4.75 4.625C5.23325 4.625 5.625 4.23325 5.625 3.75C5.625 3.26675 5.23325 2.875 4.75 2.875C4.26675 2.875 3.875 3.26675 3.875 3.75C3.875 4.23325 4.26675 4.625 4.75 4.625Z" fill="#475161" />
                            <path d="M9.25 4.625C9.73325 4.625 10.125 4.23325 10.125 3.75C10.125 3.26675 9.73325 2.875 9.25 2.875C8.76675 2.875 8.375 3.26675 8.375 3.75C8.375 4.23325 8.76675 4.625 9.25 4.625Z" fill="#475161" />
                            <path d="M4.75 8.875C5.23325 8.875 5.625 8.48325 5.625 8C5.625 7.51675 5.23325 7.125 4.75 7.125C4.26675 7.125 3.875 7.51675 3.875 8C3.875 8.48325 4.26675 8.875 4.75 8.875Z" fill="#475161" />
                            <path d="M9.25 8.875C9.73325 8.875 10.125 8.48325 10.125 8C10.125 7.51675 9.73325 7.125 9.25 7.125C8.76675 7.125 8.375 7.51675 8.375 8C8.375 8.48325 8.76675 8.875 9.25 8.875Z" fill="#475161" />
                            <path d="M4.75 13.125C5.23325 13.125 5.625 12.7332 5.625 12.25C5.625 11.7668 5.23325 11.375 4.75 11.375C4.26675 11.375 3.875 11.7668 3.875 12.25C3.875 12.7332 4.26675 13.125 4.75 13.125Z" fill="#475161" />
                            <path d="M9.25 13.125C9.73325 13.125 10.125 12.7332 10.125 12.25C10.125 11.7668 9.73325 11.375 9.25 11.375C8.76675 11.375 8.375 11.7668 8.375 12.25C8.375 12.7332 8.76675 13.125 9.25 13.125Z" fill="#475161" />
                        </svg>
                    </span>
                </Tippy>

            ))}
        </div>
    )
}

export default SvgComponent
